import { Button, Input, SidePanel } from '@hue/design-system';
import { useRef, useState } from 'react';
import { CircleHelp } from 'lucide-react';
import { GUIDE_SECTIONS } from './regex-guide-content.js';

export function RegexGuide() {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const top = useRef<HTMLDivElement>(null);
  const sections = GUIDE_SECTIONS.map((section) => ({
    ...section,
    rows: section.rows.filter((row) =>
      `${section.title} ${row.token} ${row.meaning} ${row.pattern}`
        .toLocaleLowerCase('pt-BR')
        .includes(search.toLocaleLowerCase('pt-BR')),
    ),
  })).filter((section) => section.rows.length > 0);
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="w-fit border-brand-500/40 bg-brand-500/10 text-content hover:bg-brand-500/20"
        onClick={() => setOpen(true)}
      >
        <CircleHelp className="size-4 text-brand-500" aria-hidden="true" />
        Guia de expressões regulares
      </Button>
      <SidePanel
        open={open}
        onOpenChange={setOpen}
        title="Guia de expressões regulares"
        description="Consulte os exemplos sem perder o que já escreveu na regra."
        footer={
          <>
            <Button
              type="button"
              variant="ghost"
              onClick={() => top.current?.scrollIntoView({ block: 'start' })}
            >
              Voltar ao topo do guia
            </Button>
            <Button type="button" onClick={() => setOpen(false)}>
              Voltar à regra
            </Button>
          </>
        }
      >
        <div ref={top} className="grid gap-5 text-sm text-content">
          <p>
            Uma expressão regular reconhece um padrão na descrição. Maiúsculas, minúsculas e acentos
            são ignorados: condominio também encontra CONDOMÍNIO. Use o modo Texto quando bastar
            procurar uma expressão simples.
          </p>
          <p>
            Escreva só o padrão, sem barras externas nem opções como /i. O limite é 200 caracteres.
            Não são aceitas expressões que correspondam a texto vazio, referências a grupos,
            verificações de texto antes ou depois, nem repetição depois de grupos. Nos limites
            escritos com chaves, os números devem ser de 0 a 100. Os exemplos abaixo são aceitos
            pelo sistema; confira também o testador da regra antes de salvar.
          </p>
          <Input
            label="Buscar no guia"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          {sections.length === 0 && <p>Nenhum exemplo encontrado.</p>}
          {sections.map((section) => (
            <section key={section.title} className="grid gap-3">
              <h3 className="font-semibold">{section.title}</h3>
              <ul className="grid gap-3">
                {section.rows.map((row) => (
                  <li key={row.token} className="rounded-xl border border-surface-border p-3">
                    <p>
                      <code>{row.token}</code> — {row.meaning}
                    </p>
                    <p className="mt-2">
                      Padrão: <code>{row.pattern}</code>
                    </p>
                    <p>Corresponde: {row.match}</p>
                    <p>Não corresponde: {row.noMatch}</p>
                    {row.note && <p className="mt-2 text-content-muted">{row.note}</p>}
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </SidePanel>
    </>
  );
}
